import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchFeedbackListAPI } from "../apis/feedback.api";
import { apiMessage } from "../utils/apiError.util.js";
import { getApiErrorMessage } from "../utils/upload.util.js";

const initialState = {
  isLoad: false,
  feedbackList: [],
  pagination: {
    total: 0,
    limit: 10,
    offset: 0,
    hasMore: false,
    page: 1,
    pages: 1,
  },
  lastQuery: {},
};

export const fetchFeedbackList = createAsyncThunk(
  "feedback/list",
  async (payload, thunkAPI) => {
    try {
      const response = await fetchFeedbackListAPI(payload);
      return response;
    } catch (err) {
      const message = getApiErrorMessage(err, "Failed to load feedback");
      return thunkAPI.rejectWithValue({
        success: false,
        message: apiMessage(err?.response?.data, message),
      });
    }
  }
);

const feedbackSlice = createSlice({
  name: "feedback",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchFeedbackList.pending, (state) => {
      state.isLoad = true;
    });
    builder.addCase(fetchFeedbackList.fulfilled, (state, action) => {
      state.isLoad = false;
      const { result } = action.payload || {};
      state.feedbackList = result?.list || [];
      state.pagination.total = result?.totalCount || 0;
    });
    builder.addCase(fetchFeedbackList.rejected, (state, action) => {
      state.isLoad = false;
      state.feedbackList = [];
    });
  },
});

export default feedbackSlice.reducer;
